<template lang="pug">
  .panel-page
    .panel.mx-auto.body-1
      FormErrorAlert(v-if="message" :message="message")
      h1 Edit User Agency
      form(
        @submit.prevent="submit"
        autocomplete="off"
      )
        AccountSection.mt-4(message="USER AGENCY" required)
          AgencySelector(
            :selected-agencies.sync="selectedAgencies"
            :selected-state.sync="selectedState"
            :reset-agencies-on-state-change="false"
            :state-required="true"
            :agency-required="true"
            :state-valid="!selectedStateInvalid"
            :agency-valid="!selectedAgenciesInvalid"
          )
        button.btn.btn-primary(type="submit").mr-3 Save Changes
        button.btn.btn-light(@click.prevent="$router.go(-1)") Cancel
</template>

<script>
import {
  getUserInfo,
  updateUserAgency,
  updateUserState,
} from '@/lib/services/useradmin'
import axios from '@/lib/axios'
import { globalError, globalSuccess } from '@/lib/utils'
import AccountSection from '@/components/AccountSection'
import AgencySelector from '@/components/AgencySelector'
import FormHeader from '@/components/FormHeader'
import * as validation from '@/lib/validation'
import stdmsg from '@/lib/stdmsg'

export default {
  name: 'AdminEditAgency',
  data() {
    return {
      message: '',
      selectedAgencies: [],
      selectedState: '',
      ...validation.mapTouched(['selectedState', 'selectedAgencies']),
    }
  },
  computed: {
    ...validation.mapRequired(['selectedState']),
    selectedAgenciesInvalid() {
      return this.selectedAgenciesTouched && this.selectedAgencies.length < 1
    },
    selectedAgencyIds() {
      return this.selectedAgencies.map(a => a.id)
    },
    selectedAgencyStates() {
      return this.selectedAgencies.map(a => a.state)
    },
  },
  methods: {
    ...validation.validationHelpers(),
    async submit() {
      this.markAllTouched()
      if (this.selectedStateInvalid || this.selectedAgenciesInvalid) {
        this.message = stdmsg.formError
        return
      }
      try {
        let states = new Set(this.selectedAgencyStates)
        await updateUserAgency(this.$route.query.id, this.selectedAgencyIds)
        await updateUserState(this.$route.query.id, states)
        this.$router.push({
          name: 'user_search_view',
          query: { id: this.$route.query.id },
        })
        globalSuccess(null, 'User information was successfully updated')
        scrollTo(0, 0)
      } catch (err) {
        globalError(err)
      }
    },
  },
  async beforeRouteEnter(to, _from, next) {
    try {
      // eslint-disable-next-line
      let {
        data: { agencies: ids, states },
      } = await getUserInfo(to.query.id)
      ids = ids.join(',')
      let { data: selectedAgencies } = await axios().get('/api/misc/agencies', {
        params: { ids },
      })
      next(vm => {
        vm.selectedState = states[0]
        vm.selectedAgencies = selectedAgencies
      })
    } catch (err) {
      globalError(err)
    }
  },
  components: { AgencySelector, AccountSection, FormHeader },
}
</script>

<style lang="scss" scoped>
</style>
